import React, { useEffect, useState } from 'react';
import './contact.css';
import { FaEnvelope, FaHome, FaPhone, FaPrint } from 'react-icons/fa';
import Navbar from '../navbar/Navbar';
import AOS from 'aos';
import 'aos/dist/aos.css';

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('https://electiaa.com/php/contact.php', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      const result = await response.text();
      alert(result || 'Form submitted successfully!');
      setFormData({ name: '', email: '', phone: '' });
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Failed to submit form.');
    }
  };
 useEffect(() => {
          AOS.init({
            duration: 1000,
            once: true,
          });
      
          setTimeout(() => {
            AOS.refresh();
          }, 500);
        }, []);
  return (
    <>
      <Navbar />
      <div className="contact-wrapper">
        <section className='section-margin'>
          <center>
            <div className='heading-for-all' data-aos='fade-up'>
              <h2>Contact Us</h2>
            </div>
          </center> 
        </section>

        <div className="contact-content">
          <div className="contact-form-box">
            <h3>Request a Quote</h3>
            <form onSubmit={handleSubmit}>
              <label>Name :</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
                required
              />

              <label>E-mail :</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Enter your email"
                required
              />

              <label>Phone.no :</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Enter phone number"
                required
              />

              <button type="submit" className='button-alll' style={{ width:"100%"}}>Get Enquire</button>

            </form>
          </div>

          <div className="contact-map-box">
            <p><FaHome className="me-2" /> No:21, Vinayaga Nagar,<br />Okkiyam, Thoraipakkam<br />Chennai - 600097</p>
            <p><FaEnvelope className="me-2" /> info@eletiaa.com</p>
             <p><FaEnvelope className="me-2" /> eletiaa.com@gmail.com</p>
            <p><FaPhone className="me-2" /> +91 87789 34301</p>
       
          </div>
        </div>
      </div>
    </>
  );
}

export default Contact;
